module.exports = __webpack_public_path__ + "img/02.b64adbcf.jpg";